import * as React from "react";

export type IconName =
  | "mic"
  | "arrow"
  | "check"
  | "plus"
  | "shield"
  | "git"
  | "server"
  | "spark"
  | "code"
  | "memory"
  | "clock"
  | "phone"
  | "users"
  | "github"
  | "x"
  | "discord"
  | "moon"
  | "sun"
  | "lock"
  | "puzzle"
  | "chip"
  | "star"
  | "bolt"
  | "globe"
  | "copy"
  | "menu"
  | "close";

interface IconProps {
  name: IconName;
  size?: number;
  strokeWidth?: number;
}

export function Icon({ name, size = 16, strokeWidth = 1.5 }: IconProps) {
  const props: React.SVGProps<SVGSVGElement> = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  switch (name) {
    case "mic":
      return (
        <svg {...props}>
          <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
          <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
          <line x1="12" y1="19" x2="12" y2="22" />
        </svg>
      );
    case "arrow":
      return <svg {...props}><path d="M5 12h14M12 5l7 7-7 7" /></svg>;
    case "check":
      return <svg {...props} strokeWidth={2}><polyline points="20 6 9 17 4 12" /></svg>;
    case "plus":
      return <svg {...props}><path d="M12 5v14M5 12h14" /></svg>;
    case "shield":
      return <svg {...props}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>;
    case "git":
      return (
        <svg {...props}>
          <circle cx="6" cy="6" r="3" />
          <circle cx="18" cy="18" r="3" />
          <path d="M6 9v6a6 6 0 0 0 6 6h3" />
        </svg>
      );
    case "server":
      return (
        <svg {...props}>
          <rect x="2" y="3" width="20" height="6" rx="1.5" />
          <rect x="2" y="15" width="20" height="6" rx="1.5" />
          <line x1="6" y1="6" x2="6.01" y2="6" />
          <line x1="6" y1="18" x2="6.01" y2="18" />
        </svg>
      );
    case "spark":
      return <svg {...props}><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" /></svg>;
    case "code":
      return (
        <svg {...props}>
          <polyline points="16 18 22 12 16 6" />
          <polyline points="8 6 2 12 8 18" />
        </svg>
      );
    case "memory":
      return (
        <svg {...props}>
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      );
    case "clock":
      return <svg {...props}><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>;
    case "phone":
      return <svg {...props}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></svg>;
    case "users":
      return (
        <svg {...props}>
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case "github":
      return <svg {...props}><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" /></svg>;
    case "x":
      return <svg {...props}><path d="M4 4l16 16M20 4L4 20" /></svg>;
    case "discord":
      return (
        <svg {...props}>
          <path d="M18.89 5.21a16.84 16.84 0 0 0-4.15-1.29 12.44 12.44 0 0 0-.55 1.13 15.6 15.6 0 0 0-4.65 0 12.2 12.2 0 0 0-.55-1.13 16.78 16.78 0 0 0-4.15 1.3A17.26 17.26 0 0 0 2 18.34 16.9 16.9 0 0 0 7.14 21a12.5 12.5 0 0 0 1.08-1.75 10.9 10.9 0 0 1-1.7-.82c.14-.1.28-.2.42-.32a12.04 12.04 0 0 0 10.13 0c.14.11.27.22.41.32-.54.32-1.11.59-1.7.82.31.63.67 1.2 1.08 1.75a16.85 16.85 0 0 0 5.14-2.66A17.19 17.19 0 0 0 18.89 5.2z" />
          <circle cx="9.5" cy="13" r="1.5" />
          <circle cx="14.5" cy="13" r="1.5" />
        </svg>
      );
    case "moon":
      return <svg {...props}><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" /></svg>;
    case "sun":
      return <svg {...props}><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" /></svg>;
    case "lock":
      return <svg {...props}><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>;
    case "menu":
      return <svg {...props}><path d="M3 6h18M3 12h18M3 18h18" /></svg>;
    case "close":
      return <svg {...props}><path d="M6 6l12 12M18 6L6 18" /></svg>;
    case "puzzle":
      return <svg {...props}><path d="M19 14v6a1 1 0 0 1-1 1h-6v-3a2 2 0 1 0-4 0v3H2a1 1 0 0 1-1-1v-6h3a2 2 0 1 0 0-4H1V4a1 1 0 0 1 1-1h6V1h0a2 2 0 0 1 4 0h0v2h6a1 1 0 0 1 1 1v6h-3a2 2 0 1 0 0 4z" transform="translate(2 1) scale(0.95)" /></svg>;
    case "chip":
      return (
        <svg {...props}>
          <rect x="5" y="5" width="14" height="14" rx="2" />
          <rect x="9" y="9" width="6" height="6" />
          <path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" />
        </svg>
      );
    case "star":
      return <svg {...props} strokeWidth={1.4} fill="currentColor"><polygon points="12 2 15 9 22 9.5 17 14 18.5 21 12 17.5 5.5 21 7 14 2 9.5 9 9 12 2" /></svg>;
    case "bolt":
      return <svg {...props}><path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" /></svg>;
    case "globe":
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      );
    case "copy":
      return (
        <svg {...props}>
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      );
    default:
      return null;
  }
}
